module.exports = __webpack_public_path__ + "img/huazhongda.9c6a00ec.png";